(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template-globo-backup"]) return;
  try {
    
  $(function(){
      $(".checkbox label").text(function(index, text) { 
    return text.replace('size_', ''); 
});
  })


  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  $(function(){

      $(".checkbox label").text(function(index, text) {
          return text.replace('size_', '');
      });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d100-section"] && !Shopify.designMode) return;
  try {
    
  $(window).scroll(function() {
      if ($(this).scrollTop() > 0) {
          $('#stickyAddToCart').addClass('sa-visible');
      } else {
          $('#stickyAddToCart').removeClass('sa-visible');
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-reviews"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.review-items.owl-carousel').owlCarousel({
    loop:false,
    margin:15,
    nav: false,
    dots: false,
    mouseDrag:false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        loop: true
      },
      768: {
        items: 3
      }
    }
  });

  var rv_owl = $('.review-items.owl-carousel');
  rv_owl.owlCarousel();

  $('.rv-right').on("click", function() {
    $(".rv-left").removeClass("hide__nav")
    rv_owl.trigger('next.owl.carousel');
    if($(".review-items .owl-stage > .owl-item:last-child").hasClass("active") == true) {
        $(this).addClass("hide__nav");
    }
  })

  $('.rv-left').on("click", function() {
    $(".rv-right").removeClass("hide__nav")
    rv_owl.trigger('prev.owl.carousel');
    if($(".review-items .owl-stage > .owl-item:first-child").hasClass("active") == true) {
        $(this).addClass("hide__nav");
    }
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bottom-banner"] && !Shopify.designMode) return;
  try {
    
  
  $(document).ready(function() {
    $('.bb-wrap.owl-carousel').owlCarousel({
      loop:true,
      nav: false,
      mouseDrag:false,
      items: 1,
      autoplay:false,
      autoplayTimeout:5000,
      autoplayHoverPause:false
    });

    // $( '.bb-wrap.owl-carousel .owl-dot' ).on( 'click', function() {
    //   var spotlight_count = "#spotlight-slide-" + ($(this).index() + 1);
    //   $(spotlight_count + " .ss-item-box").addClass("active");
    // });

    $('.bb-wrap.owl-carousel').on('changed.owl.carousel', function(event) {
        $(".ss-item-box").removeClass("active")
        setTimeout(function() {
          $(".owl-item.active").find(".ss-item-box").addClass("active");
        }, 100)
    });

    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
    
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
    
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    
  
      var owl_spotlight = $(".owl-item.active");
  
      
      $(window).on('scroll', function() {
        if($(window).width() > 1024) {
          if ($(".ss-items-cont").isInViewport() && $(".ss-items-cont .ss-item-box").hasClass("active") == false) {
            $(".ss-items-cont .ss-item-box").addClass("active");
          }
        } else {
          if($(".owl-item.active").find(".ss-item-box").hasClass("active") == false) {
            setTimeout(function() {
              $(".owl-item.active").find(".ss-item-box").addClass("active");
            }, 100)
          }
        }
      });

     $(window).on('resize', function() {
        if($(window).width() > 1024) {
          if ($(".ss-items-cont").isInViewport() && $(".ss-items-cont .ss-item-box").hasClass("active") == false) {
            $(".ss-item-box").addClass("active")
          }
        } else {
          setTimeout(function() {
            $(".owl-item.active").find(".ss-item-box").addClass("active");
          }, 100)
          
        }
      });


    setTimeout(function() {
      if($(window).width() >= 1025) {
        if($(".ss-items-cont").isInViewport()) {
          $(".ss-item-box").addClass("active")
        }
      } else {
        if($("#" + owl_spotlight).isInViewport()) {
          $("#" + owl_spotlight).find(".ss-item-box").addClass("active")
        }
      }
    }, 800)
    
    
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-reviews"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.review-items.owl-carousel').owlCarousel({
    loop:false,
    margin:15,
    nav: false,
    dots: false,
    mouseDrag:false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        loop: true
      },
      768: {
        items: 3
      }
    }
  });

  var rv_owl = $('.review-items.owl-carousel');
  rv_owl.owlCarousel();

  $('.rv-right').on("click", function() {
    $(".rv-left").removeClass("hide__nav")
    rv_owl.trigger('next.owl.carousel');
    if($(".review-items .owl-stage > .owl-item:last-child").hasClass("active") == true) {
        $(this).addClass("hide__nav");
    }
  })

  $('.rv-left').on("click", function() {
    $(".rv-right").removeClass("hide__nav")
    rv_owl.trigger('prev.owl.carousel');
    if($(".review-items .owl-stage > .owl-item:first-child").hasClass("active") == true) {
        $(this).addClass("hide__nav");
    }
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["io-set_image"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
  // $(".io-mp_box").addClass("active")

    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $('.io-mp-wrap-mob.owl-carousel').owlCarousel({
      loop:true,
      nav: false,
      items: 1
    });

    $('.io-mp-wrap-mob.owl-carousel').on('changed.owl.carousel', function(event) {
        $(".io-mp_box").removeClass("active")
        setTimeout(function() {
          $(".io-mp-wrap-mob .owl-item.active").find(".io-mp_box").addClass("active");
        }, 100)
    });

    var owl_spotlight = $(".io-mp-wrap-mob .owl-item.active");


    $(window).on('scroll', function() {
      if($(window).width() > 1024) {
        if ($(".ioc-visual").isInViewport() && $(".ioc-visual .io-mp_box").hasClass("active") == false) {
          $(".ioc-visual .io-mp_box").addClass("active");
        }
      } else {
        if($(".io-mp-wrap-mob .owl-item.active").find(".io-mp_box").hasClass("active") == false) {
          setTimeout(function() {
            $(".io-mp-wrap-mob .owl-item.active").find(".io-mp_box").addClass("active");
          }, 100)
        }
      }
    });

   $(window).on('resize', function() {
      if($(window).width() > 1024) {
        if ($(".ioc-visual").isInViewport() && $(".ioc-visual .io-mp_box").hasClass("active") == false) {
          $(".io-mp_box").addClass("active")
        }
      } else {
        setTimeout(function() {
          $(".io-mp-wrap-mob .owl-item.active").find(".io-mp_box").addClass("active");
        }, 100)

      }
    });


    setTimeout(function() {
      if($(window).width() >= 1025) {
        if($(".ioc-visual").isInViewport()) {
          $(".io-mp_box").addClass("active")
        }
      } else {
        if($("#" + owl_spotlight).isInViewport()) {
          $("#" + owl_spotlight).find(".io-mp_box").addClass("active")
        }
      }
    }, 800)


  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cookware_features"] && !Shopify.designMode) return;
  try {
    
  $(".cf-cta").click(function(){
    var variant_id = $(this).data('variant_id');
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: JSON.stringify({ items: [
        { id: variant_id, quantity: 1}
      ]}),
      dataType: 'json',
      contentType: 'application/json',
      success: function() {
        setTimeout(function(){
          location.assign("/cart");
        }, 1200)
      },
      error: function(xhr, status, error) {
        // Handle errors
        console.error('Error adding product lids to cart. Status: ' + status);
      }
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-key_benefits"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    var kb_items_carousel = $(".kb-items.owl-carousel").owlCarousel({
      responsive: {

          nav: false,
        0: {
          loop: true,
          dots: true,
          items: 1,
          margin: 30
        },

        768: {
          loop: false,
          dots: false,
          items: parseInt($("#kb_count").val(), 10),
          margin: 25,
          mouseDrag: false,
          touchDrag: false,
          pullDrag: false
        }
      }
    })

    $(".kb-nav-left").on("click", function() {
        kb_items_carousel.trigger('prev.owl.carousel');
    });

    $(".kb-nav-right").on("click", function() {
        kb_items_carousel.trigger('next.owl.carousel');
    });

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-marketing_points"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    var mkp_items_carousel = $(".mkp-items.owl-carousel").owlCarousel({
      responsive: {
        nav: false,
        0: {
          loop: true,
          dots: true,
          items: 1,
          margin: 30,
          padding: 20,
          slideBy: 1
        },
        
        768: {
          
          loop: true,
          dots: true,
          items: 3,
          margin: 25,
          slideBy: 3
        }
      }
    })

    
    $(".mkp-nav-left").on("click", function() {

      if($(window).width() < 768) {
        mkp_items_carousel.trigger('prev.owl.carousel');
        return false;
      }
      
      if($(".mkp-items .owl-item:not(.cloned)").length < 7) {
        
        mkp_items_carousel.trigger('next.owl.carousel');
      } else {
      
        mkp_items_carousel.trigger('prev.owl.carousel');
        
      }
      
      // if($(window).width() < 768) {
      //   mkp_items_carousel.trigger('prev.owl.carousel');
      //   return false;
      // }
      
      // var current_set = $(".mkp-items .owl-dot.active").index() + 1;
      
      // if(current_set == 1) {
      //   current_set = $(".mkp-items .owl-dots").children().length + 1;
      // }
      
      // $(`.mkp-items .owl-dot:nth-child(${current_set - 1})`).click();
    });


    $(".mkp-nav-right").on("click", function() {
      if($(window).width() < 768) {
        mkp_items_carousel.trigger('next.owl.carousel');
        return false;
      }
      
      if($(".mkp-items .owl-item:not(.cloned)").length < 7) {
        
        mkp_items_carousel.trigger('prev.owl.carousel');
      } else {
      
        mkp_items_carousel.trigger('next.owl.carousel');
        
      }
      
      // if($(window).width() < 768) {
      //   mkp_items_carousel.trigger('next.owl.carousel');
      //   return false;
      // }

      // var current_set = $(".mkp-items .owl-dot.active").index() + 1;
      
      // if(current_set == $(".mkp-items .owl-dots").children().length) {
      //   current_set = 0;
      // }
      

      // $(`.mkp-items .owl-dot:nth-child(${current_set + 1})`).click();
      
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews_carousel"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    var revcar_carousel = $(".revcar-items.owl-carousel").owlCarousel({
      responsive: {
        nav: false,
        0: {
          loop: true,
          dots: true,
          items: 1,
          margin: 10,
          stagePadding: 70,
          autoplay: true
        },

        768: {
          loop: true,
          dots: false,
          items: 3,
          margin: 10
        }
      }
    })

    $(".revcar-nav-left").on("click", function() {
        revcar_carousel.trigger('prev.owl.carousel');
    });


    $(".revcar-nav-right").on("click", function() {
        revcar_carousel.trigger('next.owl.carousel');
    });
  })

  $(".ytp-rev-cta").on("click", function() {
    $(".cta-toggle-wrap").toggleClass("collapse");
    if($("[data-yotpo-product-id] > #yotpo-reviews-main-widget").is(":hidden") == true) {
      $("[data-yotpo-product-id] > #yotpo-reviews-main-widget").slideDown();
      $(".ytp-rev-cta").text("Hide all Reviews");

    } else {
      $("[data-yotpo-product-id] > #yotpo-reviews-main-widget").slideUp();
      $(".ytp-rev-cta").text("Check all Reviews");
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-set_image"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {

    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };


    $(window).on('scroll', function() {
      if ($(".psi-wrapper").isInViewport() && $(".psi-wrapper .psi-box").hasClass("active") == false) {
          $(".psi-wrapper .psi-box").addClass("active");
      }
    });

    $(window).on('resize', function() {
      if ($(".psi-wrapper").isInViewport() && $(".psi-wrapper .psi-box").hasClass("active") == false) {
        $(".psi-box").addClass("active")
      }
    });


    if($(".psi-wrapper").isInViewport()) {
      $(".psi-box").addClass("active")
    }

    $(".psi-cta").click(function(){
      var variant_id = $(this).data('variant_id');
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        data: JSON.stringify({ items: [
          { id: variant_id, quantity: 1}
        ]}),
        dataType: 'json',
        contentType: 'application/json',
        success: function() {
          setTimeout(function(){
            location.assign("/cart");
          }, 1200)
        },
        error: function(xhr, status, error) {
          // Handle errors
          console.error('Error adding product lids to cart. Status: ' + status);
        }
      });
    })


  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_customer_reviews"] && !Shopify.designMode) return;
  try {
    

    $(function(){
		$('#selected_review_slides').owlCarousel({
          loop:true,
          nav:false,
      	  items:1,
          dots:false,
          margin:30,
      })
        
        
      	$(".customer_review.arrow_left").click(function(){
          var owl = $('#selected_review_slides');
          owl.trigger('prev.owl.carousel');
        });

        $(".customer_review.arrow_right").click(function(){
          var owl = $('#selected_review_slides');
          owl.trigger('next.owl.carousel');
        });  
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_recommend"] && !Shopify.designMode) return;
  try {
    
  var recom_items_carousel = $('#selected_recom_slides').owlCarousel({
    nav:false,
    items:1,
    dots:false,
    margin:30,
    responsive:{
      0:{
        items:1,
        loop:true,
        touchDrag: true,
        mouseDrag: true
      },
      768:{
        items:3,
        loop:false,
        mouseDrag: false,
        touchDrag: false
      }
    }
  })
  $(".precom-nav-left").on("click", function() {
      recom_items_carousel.trigger('prev.owl.carousel');
  });

  $(".precom-nav-right").on("click", function() {
      recom_items_carousel.trigger('next.owl.carousel');
  });

  } catch(e) { console.error(e); }
})();
})();
